import { timeAgo } from '@/utils/helperFunctions';
import { Box, Typography, Chip, Stack, Button, useTheme } from '@mui/material';
import { MdOutlineAccessTime } from 'react-icons/md';

export default function RecommendationCard({ item, onReject, onAddAnswer, onOpenCallLog }: any) {
  const theme = useTheme();
  return (
    <Box border={`1px solid ${theme.palette.divider}`} borderRadius={3} p={2.5} bgcolor='#fff'>
      <Stack spacing={2}>
        {/* Top row */}
        <Stack direction='row' justifyContent='space-between' alignItems='center'>
          <Stack
            direction='row'
            alignItems='center'
            gap={1}
            bgcolor={theme.palette.primary.light}
            px={1.2}
            py={0.5}
            borderRadius='12px'
            width='fit-content'
          >
            <Box width={6} height={6} borderRadius='50%' bgcolor={theme.palette.primary.main} />

            <Typography fontSize={12} fontWeight={500} color='primary'>
              Asked by {item.occurrences} callers
            </Typography>
          </Stack>

          <Stack direction='row' alignItems='center' gap={0.5} color='text.secondary'>
            <MdOutlineAccessTime size={16} />
            <Typography fontSize={12}>{timeAgo(item?.updated_at)}</Typography>
          </Stack>
        </Stack>

        <Box borderBottom='1px solid #ECECEC'>
          {/* Question */}
          <Typography fontWeight={500} fontSize={16}>
            {item.question}
          </Typography>

          {/* Description */}
          <Typography color='text.secondary' fontSize={14} mb={1.5}>
            {item.description}
          </Typography>
        </Box>

        {/* Footer */}
        <Stack direction='row' justifyContent='space-between' alignItems='center'>
          {/* Call IDs */}
          <Stack direction='row' spacing={1} flexWrap='wrap'>
            {item?.metadata?.interaction_ids?.map((callLogId: number) => (
              <Box key={callLogId} pt={0.5}>
                <Chip
                  label={`call-${callLogId}`}
                  onClick={() => onOpenCallLog(callLogId)}
                  size='small'
                  sx={{
                    bgcolor: '#FAFAFA',
                    fontSize: 12
                  }}
                />
              </Box>
            ))}
          </Stack>

          {/* Buttons */}
          <Stack direction='row' spacing={1.5}>
            <Button
              variant='outlined'
              color='error'
              sx={{
                borderRadius: '20px',

                textWrap: 'nowrap',
                px: 2
              }}
              onClick={() => onReject(item)}
            >
              Reject
            </Button>

            <Button
              variant='contained'
              sx={{ borderRadius: '20px', px: 2.5, textWrap: 'nowrap' }}
              onClick={() => onAddAnswer(item)}
            >
              Add Answer
            </Button>
          </Stack>
        </Stack>
      </Stack>
    </Box>
  );
}
